import type { ThemeColors } from '@/domain/models/theme.js';
import type { UserResponse } from '@/domain/models/user.js';
import { UserModel } from '@/domain/models/user.js';

export type AuthTokens = {
    accessToken: string;
    refreshToken: string;
};

export type LoginCredentials = {
    email: string;
    password: string;
};

export type AuthTheme = {
    colors: ThemeColors | null;
    logoUrl: string | null;
};

export type LoginResponseRaw = {
    user: UserResponse;
    accessToken: string;
    refreshToken: string;
    theme?: AuthTheme | null;
};

export type LoginResponseProps = {
    user: UserModel;
    accessToken: string;
    refreshToken: string;
    theme: AuthTheme | null;
};

export class LoginResponseModel {
    private constructor(private readonly props: LoginResponseProps) {}

    public static with(props: LoginResponseProps): LoginResponseModel {
        return new LoginResponseModel(props);
    }

    public static withFromResponse(response: LoginResponseRaw): LoginResponseModel {
        return LoginResponseModel.with({
            user: UserModel.withFromResponse(response.user),
            accessToken: response.accessToken,
            refreshToken: response.refreshToken,
            theme: response.theme ?? null
        });
    }

    public get user(): UserModel {
        return this.props.user;
    }

    public get accessToken(): string {
        return this.props.accessToken;
    }

    public get refreshToken(): string {
        return this.props.refreshToken;
    }

    public get theme(): AuthTheme | null {
        return this.props.theme;
    }

    public toObject(): LoginResponseProps {
        return { ...this.props };
    }
}

export type MeResponseRaw = UserResponse & {
    theme?: AuthTheme | null;
};

export type MeResult = {
    user: UserModel;
    theme: AuthTheme | null;
};

export type ForgotPasswordParams = {
    email: string;
};

export type ResetPasswordParams = {
    token: string;
    newPassword: string;
};

export type ChangePasswordParams = {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
};

export type ValidateTokenParams = {
    token: string;
};
